<script setup lang="ts">
const handleFinalizeCheckout = () => {
  window.location.reload();
};
</script>

<template>
  <div class="fill-height d-flex flex-column gap-6 pt-4 bg-secondary">
    <div class="d-flex flex-column gap-4 mt-6 px-4 flex-grow-1">
      <h1 class="typography-heading-md-bold d-flex align-center gap-2">
        <v-icon color="success">mdi-check-circle-outline</v-icon>
        You're checked out
      </h1>

      <p class="typography-body-md mt-auto">
        If you need any help or additional information, please contact the warehouse staff
      </p>

      <div class="pb-4">
        <v-btn block color="primary" @click="handleFinalizeCheckout">Finalize</v-btn>
      </div>
    </div>
  </div>
</template>
